import { render, staticRenderFns } from "./UseHistory.vue?vue&type=template&id=3fa699f0&scoped=true"
import script from "./UseHistory.vue?vue&type=script&lang=js"
export * from "./UseHistory.vue?vue&type=script&lang=js"
import style0 from "./UseHistory.vue?vue&type=style&index=0&id=3fa699f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa699f0",
  null
  
)

export default component.exports